<div class="content">
  <div class="controls">
    <div class="interval item">
      <div class="heading-wrap">
        <rt-heading variant="heading large">{{
          'app.pricing.plan_picker_2024.toolbar.interval_v2' | translate
        }}</rt-heading>
      </div>
      <div (click)="changeInterval()" class="toggle-interval">
        <span class="label" [class.checked]="isMonthly">{{
          'app.pricing.plan_picker_2024.toolbar.monthly_v2' | translate
        }}</span
        ><rt-toggle
          [hasMargin]="false"
          [noLabel]="true"
          [checked]="intervalChecked"
          (click)="changeInterval()"
        /><span class="label" [class.checked]="isAnnually">{{
          'app.pricing.plan_picker_2024.toolbar.annually_v2' | translate
        }}</span
        ><rt-badge
          color="success-tint"
          [text]="
            'app.pricing.plan_picker_2024.toolbar.percent_off'
              | translate: { percent: ANNUAL_DISCOUNT }
          "
        />
      </div>
    </div>
    <div class="separator"></div>
    <div class="company-size item">
      <div class="heading-wrap">
        <rt-heading variant="heading large">{{
          'app.pricing.plan_picker_2024.toolbar.employees' | translate
        }}</rt-heading>
        <rt-icon
          margin-left-auto
          name="info-outline"
          [rtTooltip]="'app.pricing.plan_picker_2024.toolbar.employees_tooltip' | translate"
        />
      </div>
      <rt-select
        [disabled]="
          sizeSelectMode() !== SizeSelectMode.Default && sizeSelectMode() !== SizeSelectMode.Agency
        "
        [options]="companySizeOptions"
        [value]="companySize()"
        [hasSearch]="false"
        [noMaxHeight]="true"
        (valueChange)="companySizeChange.emit($event)"
      />
      @switch (sizeSelectMode()) {
        @case (SizeSelectMode.LockedMinimalMissing) {
          <rt-infobox type="warning" [isDismissible]="false" iconName="warning" margin-top-small-x>
            <span
              [innerHTML]="
                'app.pricing.plan_picker_2024.toolbar.cant_verify_size_warning'
                  | translate
                    : {
                        href: 'IntercomMessage' | urlActionTrigger,
                      }
              "
            ></span>
          </rt-infobox>
        }
        @case (SizeSelectMode.Agency) {
          <rt-infobox
            type="information"
            [isDismissible]="false"
            iconName="info-outline"
            margin-top-small-x
          >
            <span
              [innerHTML]="
                'app.pricing.plan_picker_2024.toolbar.agency_info'
                  | translate
                    : {
                        href:
                          'IntercomMessage'
                          | urlActionTrigger
                            : ('app.intercom_message.optimize_for_agency' | translate),
                      }
              "
            ></span>
          </rt-infobox>
        }
        @case (SizeSelectMode.Default) {
          <span
            [innerHTML]="
              'app.pricing.plan_picker_2024.toolbar.suggested_size'
                | translate
                  : {
                      href: 'IntercomMessage' | urlActionTrigger,
                    }
            "
            class="contact-support"
          ></span>
        }
        @case (SizeSelectMode.Locked) {
          <span
            [innerHTML]="
              'app.pricing.plan_picker_2024.toolbar.contact_support_employees_number'
                | translate
                  : {
                      href: 'IntercomMessage' | urlActionTrigger,
                    }
            "
            class="contact-support"
          ></span>
        }
      }
    </div>
    <div class="currency item">
      @if (enableCurrencyChange()) {
        <rt-segmented-control
          [segmentedButtons]="currencyButtons"
          (segmentedButtonClicked)="currencyChange.emit($event)"
          type="view-switcher"
        />
      }
    </div>
  </div>
  <div class="info">
    <rt-infobox
      type="transparent"
      iconName="info-outline"
      [heading]="
        'app.pricing.plan_picker_2024.toolbar.commitment_infobox'
          | translate: { percent: ANNUAL_DISCOUNT }
      "
      [isDismissible]="false"
      [messagePaddingSmall]="true"
    />
  </div>
</div>
